<script setup lang="ts">
const props = defineProps<{
  scrollText: string | null | undefined;
  variant?: 'light' | 'dark';
  delay?: number;
}>();

const isHidden = ref(true);
onMounted(() => {
  const timer = setTimeout(() => {
    isHidden.value = false;
  }, props.delay ?? 3000);

  const cancelOnScroll = () => {
    if (isHidden.value) {
      clearTimeout(timer);
    } else {
      isHidden.value = true;
    }
    if (typeof window !== 'undefined') {
      window.removeEventListener('scroll', cancelOnScroll);
    }
  };
  if (typeof window !== 'undefined') {
    window.addEventListener('scroll', cancelOnScroll);
  }
});
</script>

<template>
  <div
    class="scrollindicator"
    :class="[props.variant, { '-is-hidden': isHidden }]"
  >
    <div class="glow">
      <img src="/icons/glow.svg" class="image" />
    </div>
    <div class="text text-2xs">{{ props.scrollText }}</div>
    <div class="arrow">
      <img
        class="icon _hidden-dark"
        src="/icons/arrow-down-white.svg"
        alt="arrow-down"
      />
      <img
        class="icon _hidden-light"
        src="/icons/arrow-down.svg"
        alt="arrow-down"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.-is-hidden {
  opacity: 0;
}

.scrollindicator {
  transition: opacity 300ms ease-in-out;
  margin-top: auto;
  display: flex;
  align-items: center;
  gap: 1rem;
  height: 5rem;
  grid-column: -3 / -1;
  justify-content: flex-end;
  position: fixed;
  right: 5rem;
  bottom: 3.5rem;

  &.light {
    .text {
      color: var(--color-white);
    }
    ._hidden-light {
      display: none;
    }
  }

  &.dark {
    .text {
      color: var(--base-color-foreground);
    }
    ._hidden-dark {
      display: none;
    }
  }

  .text {
    align-self: flex-end;
  }

  .arrow {
    height: 100%;
    width: 30px;

    .icon {
      height: 100%;
      width: 30px;
      transform: translateY(20px);
      animation: bounce 1.24s ease-in-out infinite;
    }
  }

  .glow {
    position: absolute;
    height: 15vh;
    width: 30vw;
    bottom: 0;
    right: 0;

    .image {
      max-width: 150%;
    }
  }
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-20px);
  }
}

@media (--vs) {
  .scrollindicator {
    right: 1rem;
    bottom: 1rem;
    height: 3.25rem;

    .arrow {
      width: 18px;
    }

    .glow {
      width: 70vw;
    }
  }
}
</style>
